import { CSSObject } from "@emotion/react";

export const viewMoreButtonCss: CSSObject = {
  width: "100%",
  padding: "8px",
  display: "flex",
  justifyContent: "center",
};
